import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createBrowserRouter, Outlet, RouterProvider, ScrollRestoration, } from 'react-router-dom';
import * as pages from './components/Pages';
import './index.css';
// The site used hash routing before; keep old shared links like /#/work working.
if (window.location.hash.startsWith('#/')) {
    window.history.replaceState(null, '', window.location.hash.slice(1));
}
const router = createBrowserRouter([
    {
        element: (_jsxs(_Fragment, { children: [_jsx(ScrollRestoration, {}), _jsx(Outlet, {})] })),
        children: Object.entries(pages).map(([, Element]) => ({
            ...Element,
            element: _jsx(Element, {}),
        })),
    },
]);
function App() {
    return (_jsx("div", { className: "min-h-screen w-full", children: _jsx(RouterProvider, { router: router }) }));
}
export default App;
